/**
 * * Модель элемента списка доступа пользователя
 */
export class GetUserRoleByTaskIdsItemModel {
  /**
   * * Номера id
   */
  TaskId!: number;
  /**
   * * Является участником команды очереди
   */
  IsEmployee: boolean = false;
  /**
   * * Имеет доступ
   */
  IsAdminNamespace: boolean = false;
  /**
   * * Имеет доступ
   */
  IsAdminProject: boolean = false;
  /**
   * * Является задействованым
   */
  IsOwner: boolean = false;
  /**
   * * Является исполнителем
   */
  IsPerformer: boolean = false;
  /**
   * * Является наблюдателем
   */
  IsObserver: boolean = false;
  /**
   * * Является автором
   */
  IsAuthor: boolean = false;
  /**
   * * Имеет доступ к просмотру чужих задач
   */
  VisibilityOtherTask: boolean = false;
  /**
   * * Имеет доступ к редактированию чужих задач
   */
  UpdateOtherTask: boolean = false;
  constructor(obj?: Partial<GetUserRoleByTaskIdsItemModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
